import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_DEVICE_BY_ID } from './actionTypes';
import { getDmxDeviceByIdSuccess, getDmxDeviceByIdError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getDeviceById({ payload: { user, deviceId } }) {
  try {
    const response = yield call(dmxAPI.getDeviceById, user.token, deviceId);
    yield put(getDmxDeviceByIdSuccess(response));
  } catch (error) {
    yield put(getDmxDeviceByIdError(error));
  }
}

export function* watchGetDmxDeviceById() {
  yield takeEvery(GET_DMX_DEVICE_BY_ID, getDeviceById);
}

function* getDmxDeviceByIdSaga() {
  yield all([fork(watchGetDmxDeviceById)]);
}

export default getDmxDeviceByIdSaga;
